import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import FormFooter from '../../../components/form-footer';
import IntakeInsuranceClaimHistorySubjectFields from '../../../components/intake/insurance-claim-history/subject-fields';
import InsuranceClaimHistorySubjectSchema from '../../../validation-schemas/insurance-claim-history-subject-schema';
import { updateActiveFormInsuranceClaimHistorySubject, selectActiveFormInsuranceClaimHistorySubject } from '../../../reducers/active-form-slice';
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';


const IntakeInsuranceClaimHistorySubject = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /**
     * get current form values
     */
    const backgroundScreeningSubject = useSelector(selectActiveFormInsuranceClaimHistorySubject);
    /**
     * Get client firstname and lastname in case they select "yes"
     */
    
    const { firstNameClient, lastNameClient } = useSelector((state) => state.activeForm.generalInformation);
    const { insuranceClaimHistoryDetails } = useSelector((state) => state.activeForm.insuranceClaimHistoryDetails);

    const hasValues = hasNonBlankValues(backgroundScreeningSubject);
    const hasInsuranceClaimHistoryDetails = insuranceClaimHistoryDetails === 'Yes';

    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormInsuranceClaimHistorySubject(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormInsuranceClaimHistorySubject(values));
    };

    /**
     * setup the initial values
     */
    const initialValues = {
        firstName: insuranceClaimHistoryDetails === 'Yes' ? firstNameClient : '',
        lastName: insuranceClaimHistoryDetails === 'Yes' ? lastNameClient : '',
        email: '',
        phone: '',
        address: '',
        address2: '',
        city: '',
        stateProvince: '',
        zip: '',
        country: '',
        dob: '',
        ssn: '',
        vin: '',
        licensePlate: '',
        claimNumber: '',
        licenseNumber: ''
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? backgroundScreeningSubject : initialValues}
                validationSchema={InsuranceClaimHistorySubjectSchema.fields.insuranceClaimHistorySubject}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Subject of Insurance Claim</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                                
                        <div className="form-wrapper general-information">
                            <IntakeInsuranceClaimHistorySubjectFields
                                errors={errors}
                                touched={touched}
                                values={values}
                            />
                        </div>

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues || hasInsuranceClaimHistoryDetails) && isValid)}
                            showNext={true}
                            progress={`70`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeInsuranceClaimHistorySubject;